module.exports = __webpack_public_path__ + "img/mp3.46a9219d.png";